import {writable, get} from 'svelte/store';
import {showNotification} from "../components/Notification/notification-store.js";
import {instantTranslate} from './i18n/language-store.js';
import {cartItemsStore} from "../cart/cart-store.js";

export const stocksStore = writable({});

export async function initStocksStore() {
    try {
        const timestamp = new Date().getTime();
        const response = await fetch(`./stocks.json?t=${timestamp}`);
        
        if (!response.ok) {
            throw new Error('Failed to load stocks data');
        }
        
        const stocksData = await response.json();
        stocksStore.set(stocksData);
    }
    catch (error) {
        console.error('Error loading stocks data:', error);
        stocksStore.set({});
    }
}

/**
 * Проверяет, можно ли добавить продукт в корзину с учетом ограничений по количеству
 * @param {string} recordId - ID продукта
 * @param {number} quantityToAdd - Количество для добавления
 * @returns {boolean} - true если можно добавить, false если превышен лимит
 */
export function canAddToCart(recordId, quantityToAdd) {

    const currentItems = get(cartItemsStore);
    const currentItem = currentItems.find(i => i.id === recordId);
    const currentQuantity = currentItem ? currentItem.count : 0;

    const stocks = get(stocksStore);
    const productStock = stocks[recordId];

    if (!productStock) {
        return true; // Если нет ограничений для этого продукта
    }

    // if (productStock.stop === true) {
    //     message = $t('notifications.productStopped');
    //     return false; // Если продукт остановлен
    // }

    // if (productStock.stop && new Date().getTime() > productStock.stop) {
    //     message = $t('notifications.productExpired');
    //     return false; // Если истек срок действия продукта
    // }

    if (productStock.max && productStock.max !== 0 && /^\d+$/.test(productStock.max)) {

        const newQuantity = currentQuantity + quantityToAdd;
        if (newQuantity <= (+productStock.max)) {
            return true;
        }
        else {
            /// out of stock
            showNotification(instantTranslate('notifications.maxQuantityExceeded', { max: productStock.max }));
            return false;
        }
    }

    /// DEFAULT - "CAN ADD"
    return true;
}

// Initialize stocks store when the app starts
initStocksStore(); 
